<script>
    import LiteCompareIcon from "./LiteCompareIcon";
    import LiteCompareProduct from "./LiteCompareProduct";
    import LiteCompareColors from "./LiteCompareColors";

    export default {
        name: "LiteCompareTable",
        components: {
            LiteCompareProduct,
            LiteCompareIcon,
            LiteCompareColors,
        },
        props: {
            products: {
                type: Array,
                required: true,
                default: () => [],
            },
            specifications: {
                type: Array,
                required: true,
            },
            imagesList: Object,
            inCartList: Array,
            showColorsList: Boolean,
            colorsListSize: String,
        },
        computed: {
            tableCellWidth() {
                return `${(100 / (this.products.length + 1)).toFixed(3)}%`;
            },
        },
    };
</script>

<template>
    <div class="lite-compare-table">
        <div class="lite-compare-table__row">
            <div class="lite-compare-table__cell" :style="{ width: tableCellWidth }"></div>
            <div
                v-for="product in products"
                :key="product.id"
                class="lite-compare-table__cell"
                :style="{ width: tableCellWidth }"
            >
                <lite-compare-product
                    :product="product"
                    :in-cart-list="inCartList"
                    :images-list="imagesList"
                ></lite-compare-product>
            </div>
        </div>

        <div v-if="showColorsList" class="lite-compare-table__row">
            <div class="lite-compare-table__cell">Цвет</div>
            <div
                v-for="product in products"
                :key="product.id"
                class="lite-compare-table__cell"
                :style="{ width: tableCellWidth }"
            >
                <lite-compare-colors
                    :size-type="colorsListSize"
                    :offers="product.offers"
                    :current-offer="product.offers[0]"
                ></lite-compare-colors>
            </div>
        </div>

        <div
            class="lite-compare-table__row"
            v-for="(row, rowIndex) in specifications"
            :key="rowIndex"
        >
            <div class="lite-compare-table__cell" :style="{ width: tableCellWidth }">
                {{ row.name }}
            </div>

            <template v-if="row.values">
                <div
                    class="lite-compare-table__cell"
                    v-show="!row.isSingle || valueIndex === 0"
                    :style="{ width: tableCellWidth }"
                    v-for="(value, valueIndex) in row.values"
                    :key="valueIndex"
                >
                    <template v-if="value.icons">
                        {{ value.name }}
                        <lite-compare-icon :icons="value.icons"></lite-compare-icon>
                    </template>
                    <template v-else>{{ value }}</template>
                </div>
            </template>

            <template v-if="row.icons">
                <div
                    class="lite-compare-table__cell"
                    :style="{ width: tableCellWidth }"
                    v-for="(icon, iconIndex) in row.icons"
                    :key="iconIndex"
                >
                    <lite-compare-icon :icons="icon"></lite-compare-icon>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-table__row {
        display: flex;
        align-items: center;
        text-align: center;
        &:not(:first-child) {
            border-width: 0 0 1px 0;
            border-style: solid;
            border-image: var(--lite-compare-table-row-border-gradient);
            border-image-slice: 1;
            border-color: var(--lite-compare-table-row-border-color);
        }
        .lite-compare-table__cell {
            flex-grow: 1;
            &:first-child {
                flex-shrink: 0;
                justify-content: flex-start;
                width: 100%;
                max-width: 16%;
                color: var(--lite-compare-table-cell-color--first);
                font-size: var(--lite-compare-table-cell-size--first);
                font-weight: var(--lite-compare-table-cell-weight--first);
                text-align: left;
            }
        }
    }

    .lite-compare-table__cell {
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 50px;
            padding: 12px;
            color: var(--lite-compare-table-cell-color);
            font-size: var(--lite-compare-table-cell-size);
            font-weight: var(--lite-compare-table-cell-weight);
        }
    }
</style>
